<template>
  <div id="reservationReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
            <div class="page-title">Reservation Listing</div>
            <div class="web-action-btn btn-groups text-right">
                <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                    <i class="fp-export"></i> Export
                </a>
            </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content reservation-report">
            <data-table-filter-config :moduleName="'reservationReport'" ref="filterComponent" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
                <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                <section class="bg-white data-table">
                  <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange" :moduleName="'reservationReport'" :position="'top'">
                  </custom-pagination>
                  <vue-good-table
                    mode="remote"
                    title="Reservation Report"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :totalRows="totalRecords"
                    :columns="userColumns"
                    :rows="rows"
                    :paginationOptions="{
                        enabled: false,
                        position: 'both',
                        perPage: perPage,
                        dropdownAllowAll: false,
                        setCurrentPage:listCurrentPage,
                        perPageDropdown:dropDownPerPage,
                    }"
                    :search-options="{
                    enabled: false,
                    }"

                    >
                  </vue-good-table>
                  <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange">
                  </custom-pagination>
                </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
              <div class="bg-white text-center">
                  <h1>
                      Oops!</h1>
                  <h2>
                      403 </h2>
                  <div class="error-details">
                      Sorry!, You don't have permission to access this page.
                  </div>
              </div>
          </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';


export default {
  name: "ReservationReport",
    metaInfo() {
            return {title: "Reservation Report | " +process.env.COPYRIGHT_NAME}
        },
    mixins: [commonMixins, dataTableMixins],
    data: () => ({
      cantAccessPage:"",
      permissions:[],
      loading: false,
      rows: [],
      totalRecords: 0,
      userColumns:[],
      columns: [
      {
        label: "Facility - Out",
        field: "pick_up",
        fpFieldType:"option",
        filterable: true,
        hidden:false,
      },
      {
        label: "Facility - Return",
        field: "drop_off",
        fpFieldType:"option",
        filterable: true,
        hidden:false,
      },
      {
        label: "Reservation Number",
        field: "reference_no",
        width: '50px',
        fpFieldType:"text",
        filterable: true,
        hidden:false,
      },
      {
        label: "Unit Number",
        field: "unit_no",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
        width: '90px',
      },
      {
           label: "Res Sts",
           field: "reservation_status",
           filterable: true,
           fpFieldType:"option",
           hidden:false,
      },
       {
        label: "Effective Date (Date Out)",
        field: "pickup_datetime",
        filterable: true,
        fpFieldType:"custom_date",
        hidden:false,
      },
      {
        label: "Due Out Time",
        field: "pickup_time",
        fpFieldType:"text",
        filterable: false,
        hidden:false,
        sortable:false
      },
      {
        label: "Customer Name",
        field: "company",
        fpFieldType:"text",
        filterable: true,
        hidden:false,
      },
      {
        label: "Equipment Type",
        field: "equip_type",
        fpFieldType:"option",
        filterable: true,
        hidden:false,
      },
      {
        label: "Rental Terms",
        field: "rental_term",
        fpFieldType:"integer",
        filterable: true,
        hidden:false,
      },
      {
          label: 'Cancelled By',
          field: 'cancelled_by',
          filterable: false,
          hidden:false,
          fpFieldType:"text",
          sortable: false,
      },
      {
          label: 'Cancel Reason',
          field: 'cancel_reason',
          filterable: true,
          hidden:false,
          fpFieldType:"text",
      },
      {
        label: "Contract Type",
        field: "contract_type",
        fpFieldType:"option",
        filterable: true,
        hidden:false,
      },
      {
            label: "Customer Company",
            field: "company_code",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
            filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "#company", // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: ['000','001','002'], // dropdown (with selected values) instead of text input
              trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Customer Number",
            field: "customer_number",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
        },
        {
            label: "Customer Suffix",
            field: "customer_suffix",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
            filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Customer Suffix", // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: ['000','001','002'], // dropdown (with selected values) instead of text input
              trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
        label: "Reservation From Date",
        field: "start_date",
        filterable: false,
        fpFieldType:"text",
        hidden:true,
        sortable: false,
      },
      {
        label: "Reservation To Date",
        field: "end_date",
        filterable: false,
        fpFieldType:"text",
        hidden:true,
        sortable: false,
      },

    ],
    action: 'list',
    batchProcess:0,
    batchNum:"",
    }),
    watch:{
      permissions: function(permission) {
          var self = this;
          permission.forEach(function (permissions) {
              if(permissions.name == 'reservation_listing_report') {
                  self.cantAccessPage = true;
              }
          });
          if(self.cantAccessPage == ''){
              self.cantAccessPage = false;
          }
      },
    },
    mounted: function(){
      var self = this;
      self.getPermissions();
    },
    methods:{
    // exportReports: function() {
    //     var self = this;
    //     this.action = "export";
    //     this.loadList();
    // },
    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      $.ajax({
        url: process.env.ROOT_API + "/reservation-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action


        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          console.log(data.content.row);
          if (data.status == "success") {

            // console.log('success');
            if ( self.action == "export" ||  self.action == "export_queue") {
                  if ( data.code == "201" ) {
                      alert(data.message);
                  } else {
                      if ( self.action == "export" ) {
                          self.excel = data.content.web;
                          var save = document.createElement("a");
                          save.href = self.excel;
                          save.download = data.content.web;
                          save.target = "_blank";

                          document.body.appendChild(save);
                          save.click();
                          document.body.removeChild(save);

                      } else {

                          self.batchProcess = 1;
                          self.batchNum = data.content;
                      }
                  }
                  self.action = "list";
                  // self.loadList();

            } else {
              if (data.content.row != undefined) {

                console.log("data.content.log");
                self.rows = data.content.row;
              }

              self.totalRecords = data.content.totalRecords;
            }



          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'reservation-report');
        }
      });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/ReservationReport.vue